<div class="tracking-table" [ngClass]="{ 'side-panel-open': openSidePanel }">
  <div class="tracking-table-content">
    <div
      class="tracking-table-buttons-actions"
      [class.loading]="!(rowData$ | async)?.length"
    >
      <button class="reset-button" (click)="resetFilters()">
        <img
          src="assets/icons/reset.svg"
          alt="Réinitialiser les filtres"
          style="width: 15px"
        />
        Réinitialiser les filtres
      </button>
      <button class="export-button" (click)="handleExcelExport()">
        <img
          src="assets/icons/export-excel.svg"
          alt="Exporter en Excel"
          style="width: 15px"
        />
        Export excel
      </button>
    </div>

    <ag-grid-angular
      [columnDefs]="columnDefs"
      [modules]="modules"
      [theme]="theme"
      [rowData]="rowData$ | async"
      [defaultColDef]="defaultColDef"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [rowSelection]="rowSelection"
      [treeData]="true"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [getDataPath]="getDataPath"
      [domLayout]="'normal'"
      [gridOptions]="gridOptions"
      [localeText]="localeText"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
    >
    </ag-grid-angular>

    <div class="tracking-table-side-panel">
      <lib-metadata-panel
        *ngIf="currentSidePanel === SidePanel.Metadata"
        [loadingMetadata]="loadingMetadata"
        [metadata]="currentMetadata"
        (closeSidePanel)="closeSidePanel()"
      >
      </lib-metadata-panel>

      <lib-actions-history
        *ngIf="currentSidePanel === SidePanel.ActionsHistory"
        [loadingActionsHistory]="loadingActionsHistory"
        [actionsHistory]="currentActionsHistory"
        (closeSidePanel)="closeSidePanel()"
      >
      </lib-actions-history>
    </div>
  </div>

  <div class="loading-container" *ngIf="(isLoading$ | async) && !isInitialLoad">
    <lib-little-bars-loader></lib-little-bars-loader>
    <div class="loading-container-overlay"></div>
    <p>Rafraichissement du tableau de suivi en cours ...</p>
  </div>
  <div
    class="downloading-container"
    *ngIf="(isDownloading$ | async) || (isDownloadComplete$ | async)"
  >
    <p
      class="downloading-container-is-downloading"
      *ngIf="isDownloading$ | async"
    >
      Le fichier est en cours de téléchargement...
    </p>
    <p
      class="downloading-container-is-download-complete"
      *ngIf="isDownloadComplete$ | async"
    >
      Le téléchargement est terminé !
    </p>
  </div>
</div>
